<style lang="sass" rel="stylesheet/sass">
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import sass/tabs
@import sass/tabsButton
@import sass/tabsTablesComponent
</style>

<template>
    <div
        ref="tab"
        :data-label="data.dataLabel"
        id="tabs"
        class="g_sectionTab g_mobileBottom"
        :style="`padding-top:${padding}`">
        <Paragraph
            :content="data.subTitle"
            :size="$breakpoint.isS?'L':'XL'"
            v-if="!data.tabs.hide" />
        <div
            class="g_tabs"
            role="tabpanel"
            v-if="!data.tabs.hide">
            <span
                class="g_visually_hidden"
                id="v_a11y_categories"
                v-text="accessibility.voice.youAreInTab"></span>
            <ul
                aria-labelledby="v_a11y_categories"
                role="tablist"
                v-if="data.tabs.list.length > 1">
                <li
                    :key="index"
                    v-for="(tab, index) in data.tabs.list">
                    <button
                        :aria-expanded="activeTab.id === tab.id ? 'true' : 'false'"
                        :class="{ g_active: (activeTab.id === tab.id) }"
                        :id="tab.id"
                        @click="() => { activeTab = tab; track('Tab: ' + tab.id) }">
                        <div
                            class="g_image"
                            v-img-src="{ project: false, folder: 'compare', name: tab.backgroundImage}" />
                        <Heading
                            :level="3"
                            v-html="tab.title" />
                    </button>
                </li>
            </ul>
        </div>
        <div :key="index" v-for="(tab, index) in data.subMenus">
            <component
                @changeState="value => setPaddingStyle(value)"
                :elTab="$refs.tab"
                :id="tab.id"
                :is="componentStickyBar"
                :menus="tab.menus"
                v-if="activeTab.id === tab.id"></component>
        </div>
        <div class="g_tabContent">
            <component
                :class="activeTab.id === tab.id ? 'g_active' : 'g_hide'"
                :data="tab"
                :is="component"
                :key="index"
                v-for="(tab, index) in data.tabs.list"></component>
        </div>
    </div>
</template>

<script>
// Core components
import Zone from 'gvue/src/core/Zone'
import Heading from 'gvue/src/core/Heading'
import Paragraph from 'gvue/src/core/Paragraph'
import Tracking from 'nespresso-library/src/core/tracking'

/* eslint-disable */
export default {
    name: 'Tabs',
    components: {
        Heading,
        Paragraph,
        Zone
    },
    props: {
        jsonKey: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        component: {
            type: Object,
            required: true
        },
        componentStickyBar: {
            type: Object,
            required: true
        }
    },
    data () {
        const data = this.$json[this.jsonKey]

        if (!data) {
            throw `The jsonKey "${this.jsonKey}" is not in the master file`
        }
        if (!data.tabs) {
            throw `The master does not have tabs`
        }

        if (!data.tabs.list || data.tabs.list.length === 0) {
            throw `Tabs in master are empty`
        }

        if (!data.tabs.list[0].id) {
            throw `First tabs has no ID field in master`
        }
        //        const tracking = window.landing.tracking
        const activeTab = data.tabs.list[0] || null
        //        Tracking.register({
        //            name: 'pageViewDynamic',
        //            actionId: 'demo'
        //        })
        //        Tracking.track({
        //            name: 'pageViewDynamic',
        //            action: 'changeTab',
        //            page: activeTab.id,
        //            actionId: 'demo'
        //        })
        return {
            data,
            accessibility: this.$json[this.jsonKey].tabs.accessibility,
            len: data.tabs.list.length,
            activeTab,
            padding: 0
        }
    },
    watch: {
        activeTab (value, oldValue) {
            if (value !== oldValue) {
                //                let tab = value.id
                //                const tracking = window.landing.tracking
                //                Tracking.track({
                //                    name: 'pageViewDynamic',
                //                    action: 'changeTab',
                //                    page: tab,
                //                    actionId: 'demo'
                //                })
                //                Tracking.customEvent({
                //                    category: 'User Engagement',
                //                    action: 'Click',
                //                    label: value.title,
                //                    interaction: 0
                //                })
            }
        }
    },
    mounted () {
        if (this.$hasZoneTracking) {
            this.addSectionTracking()
        }
    },
    beforeDestroy () {
        if (this.$hasZoneTracking) {
            this.deleteSectionTracking()
        }
    },
    methods: {
        track (cta) {
            Tracking.customEvent({
                category: 'User Engagement',
                action: 'Click',
                label: `${this.$trackingLandingLabel}  - Click on ${cta}`,
                interaction: 0
            })
        },
        setPaddingStyle (value) {
            this.padding = value
        }
    }
}
</script>
